<div ng-controller="documentsListController as ctrl" class="help-documents-list">
    <div ng-if="ctrl.documents.length == 0" class="list-item end-of-list">
        <div><h3>{{ctrl.noItems}}</h3></div>
        <div class="end-image" ng-bind-html="ctrl.endImage"></div>
    </div>
    <div ng-repeat="doc in ctrl.documents | orderBy:'title' track by doc.documentId" class="help-documents-list-item">
        <h1><a href="{{ctrl.docUrl(doc.documentId)}}" target="_blank">{{doc.title}}</a></h1>
        <p ng-if="doc.description">{{doc.description}}</p>
        <p>{{'help.for'|translate}} {{ctrl.targetAudience(doc.target)}}</p>
    </div>
</div>